module.exports = __webpack_public_path__ + "media/images/success_social_login-0729e25bc846ff57c3d3836042df1ee7.svg";